import { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import Loading from "../../MUI_components/loading";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import { Button, CircularProgress, Typography } from "@mui/material";
import AcountTransactionsService from "Service/Accounts/AcountTransactions.service";
import EntryTypeAccount from "Service/Accounts/JournalTypes.service"
import { REACT_QUERY_KEYS } from "Components/Constants/ReactQueryKeys";
import { useQuery } from "react-query";
import ErrorMessage from "Components/MUI_components/ErrorMessage";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import Title from "Components/Card/title";
import LedgerTypesService from "Service/Accounts/LedgerTypes.service";
import { currentLocationCode } from "Components/Constants/ReusableFunctions";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
const DoubleEntry = ({ setOpen, code, setSubmitted }) => {
  const dispatch = useDispatch();
  const Validation = yup.object({
    // transactionType: yup.string().required("Transaction type is required"),
    amount: yup.string().required("Amount type is required"),
    // type: yup.string().required("Please get any one"),
  });
  const [initValue, setInitValue] = useState({
    name:"",
    toLedgerType:null,
    toEntryType:null,
    toTransactionMode: { name: 'CASH', code: 0 },
    ledgerType:null,
    entryType:null,
    transactionMode: { name: 'CASH', code: 0 },
  });

  const [ledgerOptions,setLedgeOptions] = useState([])

  
  
    const locationCodeItem = localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION);
    const locationCode = locationCodeItem ? JSON.parse(locationCodeItem).code : '';
  
  const EntryType = [
    { name: 'DEBIT', code: 0 },
    { name: 'CREDIT', code: 1 },
  ]
  const TransactionMode = [
    { name: 'CASH', code: 0 },
    { name: 'CHEQUE', code: 1 },
  ]

   useEffect(()=> {
     const fetchLedgers = async  () => {
          try {
          let ledgerResponse = await LedgerTypesService.getAll();
          setLedgeOptions(ledgerResponse)
           } catch (e) {
              dispatch(openSnackbar(true, "error", e));
            }
        }
        fetchLedgers()
   },[])

  const handleSubmit = async (values) => {
    console.log(values);
    try {
      if (code)
        await EntryTypeAccount.edit(values, code);
      else
        await EntryTypeAccount.create(values);
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `Entry Type Accounts ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
  return (
    <>
      <Formik
        initialValues={initValue}
        //validationSchema={Validation}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form autoComplete="off">
            <div className="row mt">
            <div className="col-12">
                <FormControl
                  control="input"
                  name="name"
                  label="Transaction"
                />
              </div>
            </div>
            <div className="row mt">
                <div className="col-3" style={{textAlign:'center',marginTop:15}}>
                <Typography component="p" variant="subtitle1">
                    {COLUMNS_NAME.FROM}
                </Typography>
                </div> 
              <div className="col-3">
              <FormControl
                  control="autoComplete"
                  name="ledgerType"
                  label="Ledger Type"
                  withoutLocationFilter
                  getOptionLabel={(option) =>
                      option.name + "-" + option.code
                    }
                    options={ledgerOptions}
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="entryType"
                  label="Entry Type"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={EntryType}
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="transactionMode"
                  label="Transaction Mode"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={TransactionMode}
                />
              </div>
            </div>
            <div className="row mt">
            <div className="col-3" style={{textAlign:'center',marginTop:15}}>
            <Typography component="p" variant="subtitle1">
                {COLUMNS_NAME.TO}
            </Typography>
            </div>
              <div className="col-3">
              <FormControl
                  control="autoComplete"
                  name="toLedgerType"
                  label="Ledger Type"
                  withoutLocationFilter
                  getOptionLabel={(option) =>
                  option.name + "-" + option.code
                  }
                  options={ledgerOptions}
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="toEntryType"
                  label="Entry Type"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={EntryType}
                />
              </div>
              <div className="col-3">
                <FormControl
                  control="autoComplete"
                  name="toTransactionMode"
                  label="Transaction Mode"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={TransactionMode}
                />
              </div>
            </div>
            <div className="row flex-end mb">
              <Button
                type="submit"
                style={{ marginRight: 5 }}
                variant="contained"
                color="primary"
                //disabled={isSubmitting}
                startIcon={
                  isSubmitting && (
                    <CircularProgress color="inherit" size={20} />
                  )
                }
              >
                {code ? "Update" : "Save"}
              </Button>
              <Button
                onClick={() => setOpen(false)}
                variant="contained"
                color="secondary"
              >
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default DoubleEntry;